import { decorate, runInAction } from "mobx";
import CommonStore from "modules/CommonStore";
import ApiClient from "./api";

class OrdersStore extends CommonStore {
    constructor(rootStore, urlVersion = 1) {
        const apiClient = new ApiClient(rootStore.apiClient, urlVersion);
        super(rootStore, apiClient, rootStore.specifications["Orders"], false);

        this.specification.fields = [
            ...this.specification.fields,
            {
                name: "start_time",
                type: "datetime",
            },
        ];
    }

    isReordering = false;

    async recalcOrder(order, isUseOffer = false, isRefresh = false) {
        try {
            return await this.apiClient.recalcOrder(order.id, isRefresh, isUseOffer);
        } catch (err) {
            alert(err);
            return undefined;
        }
    }

    async extendProviderType(providersStore) {
        const providers = await providersStore.fetchList();
        runInAction(() => {
            this.specification.fields.forEach((item, key) => {
                if (item.name === "provider_type") {
                    this.specification.fields[key] = {
                        name: "provider_type",
                        type: "string",
                        formType: "select",
                        link: {
                            list: providers.map((item) => ({ id: item.short_name, name: item.name })),
                        },
                    };
                }
            });
        });
    }
    async extendProviderInfo(ordersProvidersInfo) {
        const { fields } = ordersProvidersInfo.specification;
        runInAction(() => {
            this.specification.fields.forEach((item, key) => {
                if (item.name === "providers_info") {
                    this.specification.fields[key] = {
                        ...this.specification.fields[key],
                        fields,
                    };
                }
            });
        });
    }

    async repost(id) {
        console.log("repost!", id);
        try {
            this.isReordering = true;
            const data = await this.apiClient.repost(id);
            this.fetchList(false, this.filter, this.orderBy, this.page, this.limit, true);
            this.isReordering = false;
        } catch (e) {
            this.isReordering = false;
            console.error("Error: repost order", e);
        }
        return;
    }

    async connectOrder(order_id, data) {
        runInAction(() => {
            this.changinOrdersConnectError = "";
            this.changinOrdersConnectProgress = true;
        });
        try {
            const res = await this.apiClient.connectOrder(order_id, data);
            runInAction(() => {
                this.changinOrdersConnectError = "";
                this.changinOrdersConnectProgress = false;
            });
            return res;
        } catch (e) {
            runInAction(() => {
                this.admin = null;
                this.changinOrdersConnectError = e;
                this.changinOrdersConnectProgress = false;
            });
            return null;
        }
    }
}

decorate(OrdersStore, {});

export default OrdersStore;
